// extracted by mini-css-extract-plugin
module.exports = {"auth":"Auth_auth__20qq-","error":"Auth_error__lQKSo","authForm":"Auth_authForm__Y6oeh"};